var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTiktok(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h24v24H0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.995 3.588a3.178 3.178 0 013.178 3.178v.018h.967a1.7 1.7 0 011.688 1.495l1.052 8.638a2.4 2.4 0 01-2.382 2.69H7.502a2.4 2.4 0 01-2.382-2.69L6.172 8.28A1.7 1.7 0 017.86 6.785l.956-.001.001-.018a3.178 3.178 0 013.178-3.178zm0 1.6c-.871 0-1.578.706-1.578 1.578v.018h3.156v-.018c0-.823-.63-1.5-1.434-1.572l-.144-.006z",
    fill: "#221F20",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.762 9.162h8v8h-8z"
  }), /*#__PURE__*/React.createElement("g", {
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.155 12a2.657 2.657 0 00-.324-.02c-1.323 0-2.402 1.085-2.402 2.425 0 .818.405 1.546 1.024 1.986a2.422 2.422 0 01-.644-1.65c.004-1.323 1.049-2.4 2.346-2.43V12z",
    fill: "#00FAF0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.302 14.775V9.498h.956c-.021-.11-.031-.223-.03-.336h-1.305v5.277a1.1 1.1 0 01-1.092 1.064c-.184 0-.359-.047-.508-.13.204.292.534.466.887.466a1.1 1.1 0 001.092-1.064zm2.743-3.485v-.293c-.352 0-.696-.103-.99-.297.26.297.606.504.99.59z",
    fill: "#00FAF0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.06 10.7a1.838 1.838 0 01-.448-1.202h-.35c.094.493.382.927.798 1.202zm-4.005 2.917c-.205.208-.32.49-.32.783 0 .427.238.793.588.978a1.113 1.113 0 01.112-1.43 1.09 1.09 0 011.1-.271v-1.344a2.657 2.657 0 00-.325-.022h-.055v1.034a1.003 1.003 0 00-.324-.052c-.291 0-.57.117-.776.324z",
    fill: "#FE2C55"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.045 11.29v1.025c-.678 0-1.301-.22-1.813-.59V14.4c0 1.336-1.075 2.426-2.401 2.426-.512 0-.986-.164-1.374-.44a2.39 2.39 0 001.757.776c1.323 0 2.402-1.086 2.402-2.426v-2.675c.528.384 1.162.59 1.813.59v-1.318a2.23 2.23 0 01-.384-.043z",
    fill: "#FE2C55"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.232 14.4v-2.675c.528.384 1.162.59 1.813.59V11.29a1.834 1.834 0 01-.99-.59 1.813 1.813 0 01-.793-1.202h-.956v5.277a1.1 1.1 0 01-1.092 1.065 1.08 1.08 0 01-.887-.461 1.108 1.108 0 01.508-2.086c.11 0 .221.018.324.052v-1.034c-1.297.03-2.342 1.107-2.342 2.421 0 .638.243 1.22.644 1.65.402.286.882.44 1.374.44 1.318.004 2.397-1.086 2.397-2.421z",
    fill: "#FFF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTiktok);
export default __webpack_public_path__ + "static/media/tiktok.9562aeef22d70a98748ea42e71373545.svg";
export { ForwardRef as ReactComponent };